
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Pago } from '@lib/Ventas/Pagos';

    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.CargandoSincronizarTodo )
            {
                if ( this.Buscador.Filtros.Valores.Cuenta > 0 )
                    this.Cuenta = this.Buscador.Filtros.Cuentas[this.Buscador.Filtros.Valores.Cuenta].Nombre;
                this.Id = '';
            }

        }

        public Id: string = '';
        public Cuenta: string = '';

        public CargandoSincronizarTodo: boolean = false;
        public TotalSincronizarTodo: number = 0;
        public IdSincronizarTodo: number = 0;
        public VaSincronizarTodo: number = 0;
        public SocketSincronizarTodo: string = '';
        async ActualizarSincronizarTodo( e: any )
        {
            if ( e.end )
            {
                this.Abierto = true;
                this.$socket.client.off( this.SocketSincronizarTodo );
                this.CargandoSincronizarTodo = false;
                await Wait( 100 );
                this.Controlador.RecargarEstadistica();
                await Wait( 1000 );
                this.Controlador.Buscador.Buscar( 1 );
                Utiles.Notificaciones.Completado( 'Sincronización completada' );
            } else
            {
                this.Abierto = false;
                this.VaSincronizarTodo = e.descargados;
                this.IdSincronizarTodo = e.id;
            }

        }

        async SincronizarTodo()
        {
            if ( await Utiles.Mensajes.SiNo( 'Forzar sincronización de pagos', 'Está seguro de sincronizar todas los pagos de ' + this.Cuenta + ". Este proceso no puede cancelarse." ) )
            {
                this.CargandoSincronizarTodo = true;
                let e = await Pago.DescargarTodoMercadoPago( this.Cuenta );
                if ( e )
                {
                    this.Id = '';
                    this.Abierto = false;
                    this.TotalSincronizarTodo = e.Total;
                    this.SocketSincronizarTodo = 'sincro-ml-' + e.Proceso;
                    this.$socket.client.on( this.SocketSincronizarTodo, this.ActualizarSincronizarTodo );


                } else
                {
                    Utiles.Notificaciones.Error( 'Error al buscar los pagos' );
                }
            }
        }


        public CargandoSincronizar: boolean = false;
        async Sincronizar()
        {
            this.CargandoSincronizar = true;
            let e = await Pago.DescargarMercadoPago( this.Cuenta, this.Id );
            if ( e )
            {
                this.Id = '';
                Utiles.Notificaciones.Completado( 'Pago descargado!' );
                this.Buscador.Filtros.Busqueda = this.Id;
                this.Buscador.Buscar( 1 );
            } else
            {
                Utiles.Notificaciones.Error( 'Pago no encontrado' );
            }
            this.CargandoSincronizar = false;
        }



        Cerrar()
        {
            this.Abierto = false;
        }

    }
